import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

/**
 * UserMenu component for showing the current user and logout option
 */
const UserMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  
  // Navigation handlers
  const handleSettingsClick = () => {
    // Direct to security or team based on role
    if (user.role === 'admin') {
      navigate('/admin/team');
    } else {
      navigate('/admin/security');
    }
  };
  
  const handleLogout = async () => {
    const success = await logout();
    if (success) {
      navigate('/login');
    }
  };
  
  return (
    <Menu as="div" className="relative ml-3">
      <Menu.Button className="relative flex rounded-full bg-white dark:bg-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900">
        <span className="absolute -inset-1.5" />
        <span className="sr-only">Open user menu</span>
        <div className="h-8 w-8 rounded-full bg-indigo-100 dark:bg-indigo-200 flex items-center justify-center text-sm font-medium text-indigo-700 dark:text-indigo-800">
          {user?.email?.charAt(0).toUpperCase() || 'U'}
        </div>
      </Menu.Button>
      
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white dark:bg-gray-800 py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="px-4 py-2 text-sm text-gray-700 dark:text-gray-200 border-b border-gray-200 dark:border-gray-700">
            <div className="font-medium">{user?.email}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400 capitalize">{user?.role?.replace('_', ' ')}</div>
          </div>
          
          <Menu.Item>
            {({ active, close }) => (
              <button
                onClick={() => {
                  close();
                  handleSettingsClick();
                }}
                className={`${
                  active ? 'bg-gray-100 dark:bg-gray-700' : ''
                } block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200`}
              >
                Settings
              </button>
            )}
          </Menu.Item>
          
          <Menu.Item>
            {({ active, close }) => (
              <button
                onClick={() => {
                  close();
                  handleLogout();
                }}
                className={`${
                  active ? 'bg-gray-100 dark:bg-gray-700' : ''
                } block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200`}
              >
                Sign out
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default UserMenu;